import { render, staticRenderFns } from "./crime-scene-photography.vue?vue&type=template&id=7ffc9a03&"
import script from "./crime-scene-photography.vue?vue&type=script&lang=js&"
export * from "./crime-scene-photography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports